import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Experience from "./pages/Experience";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import RedBagNew from "./pages/projects/RedBagNew";
import RedBagOld from "./pages/projects/RedBagOld";
import Retriever from "./pages/projects/Retriever";
import SleepyWoods from "./pages/projects/SleepyWoods";
import AboutMe from "./pages/AboutMe";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project/0" element={<RedBagNew />} />
          <Route path="/project/1" element={<RedBagOld />} />
          <Route path="/project/2" element={<Retriever />} />
          <Route path="/project/3" element={<SleepyWoods />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/about-me" element={<AboutMe />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
